import axios from "axios";
import config from "../constants";

const Axios = axios.create({
    baseURL: config.server
});
export default Axios;
